








import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
// https://cesium.com/public/SandcastleSampleData/big-buck-bunny_trailer.mp4

import tinymce from 'tinymce'
import Editor from '@tinymce/tinymce-vue'
// import { uploadOssFile } from '@/api/public'
// import { completeImg } from '@/utils/index'
import 'tinymce/themes/silver/theme'
import 'tinymce/plugins/link'
import 'tinymce/plugins/code'
import 'tinymce/plugins/table'
import 'tinymce/plugins/lists'
import 'tinymce/plugins/contextmenu'
import 'tinymce/plugins/wordcount'
import 'tinymce/plugins/colorpicker'
import 'tinymce/plugins/textcolor'
import 'tinymce/plugins/fullscreen'
import 'tinymce/plugins/preview'
import 'tinymce/plugins/pagebreak'
import 'tinymce/plugins/insertdatetime'
import 'tinymce/plugins/hr'
import 'tinymce/plugins/paste'
import 'tinymce/plugins/codesample'
// import "tinymce/plugins/emoticons"
import 'tinymce/icons/default/icons'

console.log(tinymce)
var placeholders = ''
// var vm: this
@Component({ name: 'TinymceEditer', components: { Editor } })
export default class extends Vue {
  //设置prop id
  @Prop({ default: 'vue-tinymce-' + +new Date() }) id!: string

  //默认高度
  @Prop({ default: 500 }) height!: number

  @Prop({ default: '' })
  private value!: string

  @Prop({ default: '' })
  private type!: string

  @Prop({ default: '' })
  private placeholder!: string

  private content: string = ''

  @Watch('value')
  private onChangeValue(newVal: string) {
    this.content = newVal
  }

  private showPlace = true
  @Watch('content')
  private onChangeContent(newVal: string) {
    if (this.content === '') {
      this.showPlace = true
    } else {
      this.showPlace = false
    }
    this.$emit('input', newVal)
  }

  editor: any = null
  //富文本框init配置
  get init() {
    return {
      selector: '#' + this.id, //富文本编辑器的id
      language: 'zh_CN', //语言
      language_url: process.env.BASE_URL + 'tinymce/zh_CN.js', //语言包
      skin_url: process.env.BASE_URL + 'tinymce/skins/ui/oxide', //编辑器需要一个skin才能正常工作，所以要设置一个skin_url指向之前复制出来的skin文件
      plugins: 'fullscreen paste lists', //插件
      toolbar: `bold italic underline
        | fontsizeselect
        | alignleft aligncenter alignright alignjustify
        | bullist numlist
        | removeformat undo redo
        | fontselect  | formatselect  | forecolor backcolor
        | fullscreen strikethrough
        | outdent indent blockquote
        | link unlink insertdatetime table hr pagebreak codesample`, //工具条
      menubar: false,
      font_formats:
        'Arial=arial,helvetica,sans-serif;宋体=SimSun;微软雅黑=Microsoft Yahei;Impact=impact,chicago;', //字体
      fontsize_formats: '11px 12px 14px 16px 18px 24px 36px 48px 64px 72px', //文字大小
      height: 345, //高度
      branding: false, //水印
      elementpath: false, //底部元素路径
      paste_data_images: false, //禁止粘贴图片
      
      //初始化前执行
      setup: (editor: any) => {
        this.editor = editor
        editor.on('init', function () {
          //   if (editor.getContent() == ''){
          //     editor.setContent(`<p class='placeholder' id='placeholder' style="color:#bebebe;font-size:14px">请输入</p>`)
          //     //  tinymce.get('Text').setContent('<p id=>Your nice text here!</p>')
          //   }
        })
        editor.on('focus', function () {
          // var element = editor.Html()
          // console.log(element)
          // element?.remove()
        })
      },
      //实例化执行
      init_instance_callback: (editor: any) => {
        this.content && editor.setContent(this.content)
        //this.hasInit = true
        editor.on('NodeChange Change KeyUp SetContent', () => {
          // var element = editor.iframeHTML

          // console.log(element)
          //this.hasChange = true
          this.content = editor.getContent()
        })
      },
    }
  }

  private mounted() {
    placeholders = this.placeholder
    this.content = this.value
  }

  toBase64File(file: any): Promise<string> {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader()
      fileReader.readAsDataURL(file)
      fileReader.onload = () => {
        resolve(fileReader.result as string)
      }
    })
  }

  focusEditor() {
    this.editor.focus()
  }
}
